import {
  AddOnBillingStatus,
  AddOnKey,
  type ISubscriptionAddOn,
} from '@principle-theorem/principle-core/interfaces';
import { toTimestamp } from '@principle-theorem/shared';
import * as moment from 'moment-timezone';
import { SubscriptionAddOns } from './subscription-add-ons';

export function MockSubscriptionAddOn(
  overrides: Partial<ISubscriptionAddOn> = {}
): ISubscriptionAddOn {
  const addOn: ISubscriptionAddOn = {
    addOnKey: AddOnKey.AiImagingAnalysis,
    stripeProductId: 'prod_ai_imaging',
    stripePriceId: 'price_ai_imaging',
    stripeSubscriptionItemId: 'si_ai_imaging',
    billingStatus: AddOnBillingStatus.Active,
    createdAt: toTimestamp(moment('2026-01-01T00:00:00Z')),
    active: true,
    ...overrides,
  };

  return {
    ...addOn,
    active: overrides.active ?? SubscriptionAddOns.isAddOnActive(addOn),
  };
}
